import type { StripeCustomerData } from '../../repositories/stripe-account-repo/schemas/customer.zod';
import { StripePaymentMethod } from '../payment-method';
import { StripePriceVO } from '../price';
import { StripeSubscription } from '../stripe-subscription';
import { StripeUpcomingInvoice } from '../upcoming-invoice';

export class StripeCustomer {
  constructor(private readonly values: StripeCustomerData) {}

  public toJson() {
    return this.values;
  }

  public getBalance() {
    return new StripePriceVO(this.values.customer.balance, this.values.customer.currency);
  }

  public getUpcomingInvoice() {
    if (!this.values.upcomingInvoice) {
      return null;
    }

    return new StripeUpcomingInvoice(this.values.upcomingInvoice);
  }

  public getSubscription() {
    if (!this.values.subscription) {
      return null;
    }

    return new StripeSubscription(this.values.subscription);
  }

  public getPaymentMethod() {
    if (!this.values.paymentMethod) {
      return null;
    }

    return new StripePaymentMethod(this.values.paymentMethod);
  }

  public getIsHouseAccount() {
    return this.values.customer.metadata.is_house?.toLowerCase() === 'true';
  }

  public getIsSingleBillChildAccount() {
    const parentPuid = this.values.customer.metadata.parent_puid?.trim();
    const paysFor = this.values.customer.metadata.pays_for?.trim().toLowerCase();

    return Boolean(parentPuid) && paysFor === 'none';
  }

  public getIsCoreMutationLockedAccount() {
    return this.getIsHouseAccount() || this.getIsSingleBillChildAccount();
  }
}
